import "./Home.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import KigaliUrbanHeritageHero from "./sections/KigaliUrbanHeritageHero";
import NewArrivals from "./sections/NewArrivals";
import ProductDetails from "./sections/ProductDetails";
import TheOptimaProtocol from "./sections/TheOptimaProtocol";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <VoltMainHeader />
      <KigaliUrbanHeritageHero />
      <NewArrivals />
      <ProductDetails />
      <TheOptimaProtocol />
      <Footer />
    </div>;
}